import { Icon } from '@chakra-ui/react';

export default function TeamsFilledIcon(props) {
  return (
    <Icon
      boxSize={5}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.9626 8.28125H16.8371C17.2032 8.28125 17.4999 8.57366 17.4999 8.93437V12.4121C17.4999 13.7378 16.4093 14.8125 15.064 14.8125H15.0525C13.7072 14.8127 12.6164 13.7381 12.6162 12.4124C12.6162 12.4123 12.6162 12.4122 12.6162 12.4121V8.6226C12.6162 8.43407 12.7713 8.28125 12.9626 8.28125Z'
        fill='#FEFFFF'
        stroke='#0F86FA'
      />
      <path
        d='M15.5815 7.59375C16.4484 7.59375 17.1513 6.90119 17.1513 6.04688C17.1513 5.19256 16.4484 4.5 15.5815 4.5C14.7145 4.5 14.0117 5.19256 14.0117 6.04688C14.0117 6.90119 14.7145 7.59375 15.5815 7.59375Z'
        fill='#FEFFFF'
        stroke='#0F86FA'
      />
      <path
        d='M10.6976 7.59376C11.9499 7.59376 12.9651 6.59339 12.9651 5.35938C12.9651 4.12536 11.9499 3.125 10.6976 3.125C9.44535 3.125 8.43018 4.12536 8.43018 5.35938C8.43018 6.59339 9.44535 7.59376 10.6976 7.59376Z'
        fill='#FEFFFF'
        stroke='#0F86FA'
      />
      <path
        d='M13.7211 8.28125H7.32556C6.96387 8.29007 6.67775 8.58586 6.68614 8.94228V12.9088C6.63564 15.0477 8.35287 16.8227 10.5234 16.875C12.6938 16.8227 14.4111 15.0477 14.3606 12.9088V8.94228C14.3689 8.58586 14.0828 8.29007 13.7211 8.28125Z'
        fill='#FEFFFF'
        stroke='#0F86FA'
      />
      <path
        opacity='0.1'
        d='M10.8718 8.28125V13.8397C10.87 14.0946 10.7133 14.3236 10.4741 14.4206C10.3979 14.4524 10.3161 14.4687 10.2334 14.4688H6.99271C6.94736 14.3553 6.9055 14.2419 6.87061 14.125C6.7485 13.7306 6.6862 13.3205 6.68573 12.9081V8.94125C6.67734 8.58539 6.96299 8.29007 7.3241 8.28125H10.8718Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.5229 8.28125V14.1834C10.5229 14.2649 10.5063 14.3456 10.4741 14.4206C10.3756 14.6563 10.1432 14.8108 9.88457 14.8125H7.15666C7.09736 14.6991 7.04155 14.5856 6.99271 14.4688C6.94387 14.3519 6.9055 14.2419 6.87061 14.125C6.7485 13.7306 6.6862 13.3205 6.68573 12.9081V8.94125C6.67734 8.58539 6.96299 8.29007 7.3241 8.28125H10.5229Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.5229 8.28125V13.4959C10.5203 13.8423 10.236 14.1224 9.88457 14.125H6.87061C6.7485 13.7306 6.6862 13.3205 6.68573 12.9081V8.94125C6.67734 8.58539 6.96299 8.29007 7.3241 8.28125H10.5229Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.1741 8.28125V13.4959C10.1714 13.8423 9.88718 14.1224 9.53573 14.125H6.87061C6.7485 13.7306 6.6862 13.3205 6.68573 12.9081V8.94125C6.67734 8.58539 6.96299 8.29007 7.3241 8.28125H10.1741Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.1'
        d='M10.8722 6.50406V7.58687C10.8129 7.5903 10.7571 7.59375 10.6978 7.59375C10.6385 7.59375 10.5827 7.59031 10.5234 7.58687C10.4056 7.57917 10.2889 7.56076 10.1746 7.53187C9.46816 7.36702 8.88457 6.87884 8.60479 6.21875C8.55665 6.1079 8.51928 5.99279 8.49316 5.875H10.2339C10.5859 5.87631 10.8709 6.15718 10.8722 6.50406Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.5231 6.84781V7.58687C10.4053 7.57917 10.2886 7.56076 10.1743 7.53187C9.46786 7.36703 8.88426 6.87884 8.60449 6.21875H9.88472C10.2367 6.22006 10.5218 6.50093 10.5231 6.84781Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.5231 6.84781V7.58687C10.4053 7.57917 10.2886 7.56076 10.1743 7.53187C9.46786 7.36703 8.88426 6.87884 8.60449 6.21875H9.88472C10.2367 6.22006 10.5218 6.50093 10.5231 6.84781Z'
        fill='#FEFFFF'
      />
      <path
        opacity='0.2'
        d='M10.1743 6.84781V7.53187C9.46786 7.36703 8.88426 6.87884 8.60449 6.21875H9.53589C9.8879 6.22007 10.1729 6.50094 10.1743 6.84781Z'
        fill='#FEFFFF'
      />
      <path
        d='M3.13942 6.21875H9.535C9.88814 6.21875 10.1744 6.50085 10.1744 6.84884V13.1512C10.1744 13.4991 9.88813 13.7812 9.535 13.7812H3.13942C2.78627 13.7812 2.5 13.4991 2.5 13.1512V6.84884C2.5 6.50085 2.78628 6.21875 3.13942 6.21875Z'
        fill='#FEFFFF'
        stroke='#0F86FA'
      />
      <path
        d='M8.01988 8.6174H6.74138V12.048H5.92686V8.6174H4.6543V7.9519H8.01988V8.6174Z'
        fill='#0F86FA'
      />
    </Icon>
  );
}
